import { useCallback, useEffect, useState } from 'react'
import { PermissionPolicyOption } from '../../domain/value-object/PermissionPolicy'
import { usePermissionPolicyRepository } from '../../services/adaptors/permissionPolicyRepositoryAdaptor'
import { permissionPolicyService } from '../../domain/entity/PermissionPolicyEntity'

export const usePermissionPolicyOptions = () => {
  const [initialized, setInitialized] = useState(false)
  const [allPermissionPolicyOptions, setAllPermissionPolicyOptions] = useState<
    PermissionPolicyOption[]
  >([])
  const [
    attachedByDefaultPermissionPolicies,
    setAttachedByDefaultPermissionPolicies,
  ] = useState<PermissionPolicyOption[]>([])
  const [
    attachablePermissionPolicyOptions,
    setAttachablePermissionPolicyOptions,
  ] = useState<PermissionPolicyOption[]>([])
  const [
    attachableToUserPermissionPolicyOptions,
    setAttachableToUserPermissionPolicyOptions,
  ] = useState<PermissionPolicyOption[]>([])
  const [
    attachableToProjectMemberPermissionPolicyOptions,
    setAttachableToProjectMemberPermissionPolicyOptions,
  ] = useState<PermissionPolicyOption[]>([])
  const permissionPolicyRepository = usePermissionPolicyRepository()

  const fetchPolicies = useCallback(async () => {
    try {
      const policies = await permissionPolicyRepository.getList()
      const allPolicies: PermissionPolicyOption[] = []
      const attachedByDefaultPolicies: PermissionPolicyOption[] = []
      const attachablePolicies: PermissionPolicyOption[] = []
      const attachableToUserPolicies: PermissionPolicyOption[] = []
      const attachableToProjectMemberPolicies: PermissionPolicyOption[] = []
      policies.forEach(policy => {
        const policyOption = {
          uuid: policy.uuid,
          name: policy.name,
          type: policy.type,
          description: policy.description,
          attachable: policy.attachable,
          attachedByDefault: policy.attachedByDefault,
          scopes: policy.scopes,
        }
        allPolicies.push(policyOption)
        if (permissionPolicyService.isAttachedByDefault(policy)) {
          attachedByDefaultPolicies.push(policyOption)
        }
        if (permissionPolicyService.isAttachable(policy)) {
          attachablePolicies.push(policyOption)
        }
        if (permissionPolicyService.isAttachableToUser(policy)) {
          attachableToUserPolicies.push(policyOption)
        }
        if (permissionPolicyService.isAttachableToProjectMember(policy)) {
          attachableToProjectMemberPolicies.push(policyOption)
        }
      })
      setAllPermissionPolicyOptions(allPolicies)
      setAttachedByDefaultPermissionPolicies(attachedByDefaultPolicies)
      setAttachablePermissionPolicyOptions(attachablePolicies)
      setAttachableToUserPermissionPolicyOptions(attachableToUserPolicies)
      setAttachableToProjectMemberPermissionPolicyOptions(
        attachableToProjectMemberPolicies
      )
    } finally {
      setInitialized(true)
    }
  }, [permissionPolicyRepository])

  useEffect(() => {
    fetchPolicies()
  }, [fetchPolicies])

  return {
    initialized,
    allPermissionPolicyOptions,
    attachedByDefaultPermissionPolicies,
    attachablePermissionPolicyOptions,
    attachableToUserPermissionPolicyOptions,
    attachableToProjectMemberPermissionPolicyOptions,
    refetch: fetchPolicies,
  }
}
